export default class ResetPassword {
	public email: string;
}
